import { setClass, useViewModel } from '@utils';
import React, { useEffect } from 'react';
import { VersionService } from './VersionService';
import { observer } from 'mobx-react-lite';
import { isMobile } from 'react-device-detect';
import '../../styles/components/version.scss';

export const Version = observer(() => {
  const versionService = useViewModel(VersionService);

  useEffect(() => versionService.getVersion(), []);

  return (
    <div className={setClass('version-area', isMobile && 'mobile')}>
      <div className='version-part'>
        <span className='version'>v.{versionService.stringifyVersion[0]}</span>
        <span className='version'>v.{versionService.stringifyVersion[1]}</span>
      </div>
      <div className='version-part'>
        <span className='version-title'>App </span>
        <span className='version-title'>DB </span>
      </div>
    </div>
  );
});